import React from 'react';
import { useSearchkit } from '@searchkit/client';
import classNames from 'classnames';
export var ListFacet = function ListFacet(_ref) {
  var facet = _ref.facet;
  var api = useSearchkit();
  return /*#__PURE__*/React.createElement("div", {
    className: "Facet ListFacet",
    key: facet.identifier
  }, /*#__PURE__*/React.createElement("span", null, facet.label), /*#__PURE__*/React.createElement("ul", null, facet.entries.map(function (entry) {
    var isSelected = api.isFilterSelected({
      identifier: facet.identifier,
      value: entry.label
    });
    var classes = classNames({
      selected: isSelected,
      disabled: parseInt(entry.count) === 0
    });
    return /*#__PURE__*/React.createElement("li", {
      className: classes,
      key: entry.label
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        api.toggleFilter({
          identifier: facet.identifier,
          value: entry.label
        });
        api.setPage({
          from: 0
        });
        api.search();
      },
      disabled: parseInt(entry.count) === 0
    }, entry.label, " (", entry.count, ")"));
  })));
};
ListFacet.DISPLAY = 'ListFacet';
export default ListFacet;